import { ComponentType, lazy } from "react";

/**
 * HomeV3 login body for the shared modal. `lazy()` keeps LoginBody out of the
 * SiteHeader bundle until the modal opens; one Suspense boundary in LoginWrapper
 * handles loading (no second loader from a mount-time dynamic import).
 */
const SiteLoginBodyBridge = lazy(
  () => import("@Pages/HomeV3/components/LoginBody"),
) as ComponentType;

export default SiteLoginBodyBridge;
